export class NewTokenRequest {
    proof: File
    amount: number;

    constructor(amount: number, proof: File) {
        this.proof = proof;
        this.amount = amount;
    }
}